import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faUsers, faBox, faFileContract, faUserTie, 
    faWarehouse, faShoppingCart, faUser, faFilePdf 
} from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';  
import logo from '../assets/Logo-HM.png';
import img from '../assets/User.png';
import jwt_decode from 'jwt-decode';

function Index() {
    const [search, setSearch] = useState('');
    const navigate = useNavigate();

    // Obtener el rol de admin desde el token JWT
    const token = localStorage.getItem('access_token');
    const decodedToken = token ? jwt_decode(token) : null;
    const isAdmin = decodedToken?.es_admin || false; 

    const tables = [
        {id: "PDF", name: 'Momimientos en Almacén de TI', route: '/Movimientos-pdf', icon: faFilePdf },
        { id: "PDF", name: 'Resguardo de Equipo', route: '/Resguardo-pdf', icon: faFilePdf },
         { id: "PDF", name: 'Diagnosticos de Equipo', route: '/Diagnostico-pdf', icon: faFilePdf },
    ];

    const filteredTables = tables.filter((table) =>
        table.name.toLowerCase().includes(search.toLowerCase())
    );

    const handleCardClick = (route) => {
        navigate(route);
    };

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('isAdmin'); 
        navigate('/');
    };

    return (
        <motion.div
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            style={{ fontFamily: 'Arial, sans-serif' }}
        >
            {/* Navbar */}
            <nav
                style={{
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '10px 20px',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img
                        src={logo}
                        alt="Logo HM"
                        style={{
                            height: '80px',
                            marginRight: '10px',
                            borderRadius: '5px',
                        }}
                    />
                    <h2 style={{ margin: 0 }}>Sistemas de Administración de Activos</h2>
                </div>
                <button
                    onClick={handleLogout}
                    style={{
                        backgroundColor: '#f50057',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 15px',
                        borderRadius: '5px',
                        cursor: 'pointer',
                    }}
                >
                    Cerrar Sesión
                </button>
            </nav>

            <h1 style={{ textAlign: 'center', marginTop: '20px' }}>Formato de PDF</h1>

            {/* Tarjetas del panel */}
            <div
                style={{
                    display: 'flex',
                    gap: '20px',
                    flexWrap: 'wrap',
                    justifyContent: 'center',
                    padding: '20px',
                }}
            >
                {filteredTables.map((table) => (
                    <div
                        key={table.name}
                        onClick={() => handleCardClick(table.route)}
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '10px',
                            padding: '20px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            width: '200px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            backgroundColor: '#f9f9f9',
                            transition: 'transform 0.3s ease',
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    >
                        <FontAwesomeIcon
                            icon={table.icon}
                            style={{ fontSize: '40px', color: table.id === 'PDF' ? '#d32f2f' : '#1976d2', marginBottom: '10px' }}
                        />
                        <h3 style={{ margin: '10px 0' }}>{table.name}</h3>
                    </div>
                ))}
            </div>
        </motion.div>
    );
}

export default Index;
